import styled from "styled-components";
import { fonts } from "assets/fontStyles";
import { FieldWrapper, Error } from "components/shared/form";
import { StyledButton } from "components/button/styles";
import { Row } from "components/shared/layout";
import * as Checkbox from "components/checkbox/styles";
import queries, { devices } from "utils/responsivenessHelper";

const { iPad, iPadPro } = { ...devices };

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20% 0%;
`;

const Title = styled.div`
  ${fonts.title};
  font-size: 3.75rem;

  ${queries.both(
    {
      ...fonts.titleMobile,
      maxWidth: "80%",
    },
    devices.phone
  )};
  ${queries.both(
    {
      fontSize: "2.75rem",
      maxWidth: "80%",
    },
    devices.iPad
  )};
`;

const FormContainer = styled.div`
  width: 85%;
  max-width: 680px;
  display: flex;
  justify-content: center;
  margin: 40px auto;
  /* margin: 9.27% auto 3.23% auto; */

  ${FieldWrapper} {
    padding: 4%;
    margin: auto;
    width: 100%;
  }
  ${StyledButton} {
    margin-top: 3.625em;
    width: 17.125em;
    max-width: 60%;

    @media screen and (max-width: 767px) {
      margin: 2.1875em 0em 1.6em 0em;
    }
  }

  ${queries.portrait(
    {
      width: "55%",
    },
    devices.iPad
  )};

  ${queries.portrait(
    {
      width: "85%",
    },
    devices.iPadPro
  )};
`;

const CheckboxRow = styled(Row)`
  justify-content: center;
  width: 100%;
  padding-top: 1em;

  ${FieldWrapper} {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    padding: 0;
  }

  ${Checkbox.CheckboxLabel} {
    text-align: center;
    ${queries.portrait({ fontSize: "1.25rem" }, iPad)};
    ${queries.portrait({ fontSize: "1.25rem" }, iPadPro)};
    a {
      font-size: inherit;
    }
  }

  ${Error} {
    white-space: pre-wrap;
    justify-content: center;
    text-align: center;
  }
`;

export { Container, Title, FormContainer, CheckboxRow };
